import { RentalAdvert, RentalAdvertTranslation } from "../../../types/types";
import * as React from "react"
import SimpleFormat from "../../../utils/SimpleFormat";
import * as Immutable from 'immutable'
import { GeneralRentalBooleans, InteriorRentalBooleans } from "../../../advert_detail/booleans";
import ReadMore from "../../shared/advert/ReadMore";
import RentalBooleanList from "./RentalBooleanList";
type Props = {
  advert: RentalAdvert
  translation: RentalAdvertTranslation
}

export default (props: Props) : JSX.Element => {
  const booleans = Immutable.OrderedSet(GeneralRentalBooleans()).merge(InteriorRentalBooleans()).filter(x => props.advert[x]).toOrderedSet()

  return booleans.count() > 0 || (!!props.translation && props.translation.interior) ? <>
    <div className="advert-intro">
      <h2>
        {I18n.t(`rental_adverts.description.interior.${props.advert.objectType}`)}
      </h2>
      {
        !!props.translation && props.translation.interior ?
          <div>
            <div className="description">
              <ReadMore
                height={180}
              >
                <SimpleFormat
                  text={props.translation.interior}
                />
              </ReadMore>
            </div>
          </div>
        : ''
      }

      {
        booleans.count() > 0 ?
          <>
            <hr/>
            <h3>
              {I18n.t('rental_adverts.description.facilities')}
            </h3>

            <RentalBooleanList
              advert={props.advert}
              booleans={booleans}
            />
          </>
        : ''
      }
    </div>
    <hr />
  </> : <></>
}
